import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * 病院管理者ユーザーからの招待メール機能
 *
 * 病院管理者ユーザーからの招待メールを送信する
 */
export class PostInvitation implements APIRequest<Monitaro.PostInvitationResponse> {
  response: Monitaro.PostInvitationResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  params: Monitaro.InvitationRequest

  constructor(params: Monitaro.InvitationRequest) {
    this.params = params
    this.path = '/invitations'
  }
}
